import { PackageServiceActionTypes } from './types';
import { settings } from '../../../settings';
import { ProductType } from '../../../globalTypes';
import { ClientHelper, store } from '../../../index';
import FormDataClient from '../../client/FormDataClient';
import ResponseStatus from '../../../globalTypes/ResponseStatus';
var coreBaseUrl = settings.coreApi.host + settings.coreApi.prefix;
export function getPackageFormData() {
    var action = {
        type: PackageServiceActionTypes.RECEIVE_PACKAGE_FORM_DATA_RESPONSE,
        formData: null
    };
    FormDataClient.fetchAndDispatchFormDataAsync(ProductType.PACKAGE, action, true);
}
export function getPackageProducts(productRequest, storageKey, appendResponse, updateState) {
    if (storageKey === void 0) { storageKey = 'default'; }
    if (appendResponse === void 0) { appendResponse = false; }
    if (updateState === void 0) { updateState = true; }
    var protocol = store.getState().websiteState.app.location.protocol;
    var apiEndpoint = settings.coreApi.endPoints.package.base + settings.coreApi.endPoints.package.products;
    if (updateState) {
        ClientHelper.abortPreviousRequest(store.getState().coreState.package.products.get(storageKey).abortController);
    }
    var abortController = new AbortController();
    var lastProducts = JSON.parse(JSON.stringify(store.getState().coreState.package.products.get(storageKey).products || []));
    if (updateState) {
        if (appendResponse) {
            ClientHelper.dispatchNewRequestAction(storageKey, PackageServiceActionTypes.REQUEST_MORE_PACKAGE_PRODUCTS, abortController);
        }
        else {
            ClientHelper.dispatchNewRequestAction(storageKey, PackageServiceActionTypes.REQUEST_PACKAGE_PRODUCTS, abortController);
        }
    }
    var result = {
        storageKey: storageKey,
        type: PackageServiceActionTypes.RECEIVE_PACKAGE_PRODUCTS_RESPONSE,
        products: [],
        status: ResponseStatus.FAILED
    };
    if (productRequest.query.PRODUCT_GROUPS === void 0 || productRequest.query.PRODUCT_GROUPS === null || productRequest.query.PRODUCT_GROUPS === []) {
        result.status = ResponseStatus.EMPTY;
        store.dispatch(result);
    }
    else {
        fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
            signal: abortController.signal,
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: settings.coreApi.defaultPostHeaders,
            body: JSON.stringify(productRequest)
        }).then(function (response) {
            if (response.status === 200) {
                response.json().then(function (data) {
                    result.products = data;
                    if (data && data.pageInfo && data.pageInfo.size > 0) {
                        result.status = ResponseStatus.SUCCEED;
                    }
                    else {
                        result.status = ResponseStatus.EMPTY;
                    }
                    if (updateState) {
                        if (appendResponse) {
                            result.products['products'] = lastProducts.concat(data['products']);
                        }
                        store.dispatch(result);
                    }
                });
            }
            else {
                console.error('Error while fetching products', response.status, response);
                store.dispatch(result);
            }
        }).catch(function (error) {
        });
    }
}
export function getPackageGroups(request, storageKey, optionalQuery) {
    if (storageKey === void 0) { storageKey = 'default'; }
    if (optionalQuery === void 0) { optionalQuery = ''; }
    var protocol = store.getState().websiteState.app.location.protocol;
    var apiEndpoint = settings.coreApi.endPoints.package.base + settings.coreApi.endPoints.package.groups;
    ClientHelper.abortPreviousRequest(store.getState().coreState.package.groups.get(storageKey).abortController);
    var abortController = new AbortController();
    ClientHelper.dispatchNewRequestAction(storageKey, PackageServiceActionTypes.REQUEST_PACKAGE_GROUPS, abortController);
    var result = {
        storageKey: storageKey,
        type: PackageServiceActionTypes.RECEIVE_PACKAGE_GROUPS_RESPONSE,
        groups: {},
        status: ResponseStatus.FAILED
    };
    fetch(protocol + '//' + coreBaseUrl + apiEndpoint + optionalQuery, {
        signal: abortController.signal,
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: settings.coreApi.defaultPostHeaders,
        body: JSON.stringify(request)
    }).then(function (response) {
        if (response.status === 200) {
            response.json().then(function (data) {
                result.groups = data;
                if (data && ((data.productGroups && data.productGroups.length > 0) || (data.flatProductGroups && Object.keys(data.flatProductGroups).length > 0))) {
                    result.status = ResponseStatus.SUCCEED;
                }
                else {
                    result.status = ResponseStatus.EMPTY;
                }
                store.dispatch(result);
            });
        }
        else {
            console.error('Error while fetching groups', response.status, response);
            store.dispatch(result);
        }
    }).catch(function (error) {
    });
}
export function getPackageOffers(productRequest, storageKey, appendResponse) {
    if (storageKey === void 0) { storageKey = 'default'; }
    if (appendResponse === void 0) { appendResponse = false; }
    var protocol = store.getState().websiteState.app.location.protocol;
    var apiEndpoint = settings.coreApi.endPoints.package.base + settings.coreApi.endPoints.package.offers;
    ClientHelper.abortPreviousRequest(store.getState().coreState.package.offers.get(storageKey).abortController);
    var abortController = new AbortController();
    var lastProducts = JSON.parse(JSON.stringify(store.getState().coreState.package.products.get(storageKey).products || []));
    if (appendResponse) {
        ClientHelper.dispatchNewRequestAction(storageKey, PackageServiceActionTypes.REQUEST_MORE_PACKAGE_OFFERS, abortController);
    }
    else {
        ClientHelper.dispatchNewRequestAction(storageKey, PackageServiceActionTypes.REQUEST_PACKAGE_OFFERS, abortController);
    }
    var result = {
        storageKey: storageKey,
        type: PackageServiceActionTypes.RECEIVE_PACKAGE_OFFERS_RESPONSE,
        offers: {},
        status: ResponseStatus.FAILED
    };
    fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
        signal: abortController.signal,
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: settings.coreApi.defaultPostHeaders,
        body: JSON.stringify(productRequest)
    }).then(function (response) {
        if (response.status === 200) {
            response.json().then(function (data) {
                result.offers = data;
                if (data && data.pageInfo && data.pageInfo.size > 0) {
                    result.status = ResponseStatus.SUCCEED;
                }
                else {
                    result.status = ResponseStatus.EMPTY;
                }
                if (appendResponse) {
                    result.offers['products'] = lastProducts.concat(data['products']);
                }
                store.dispatch(result);
            });
        }
        else {
            console.error('Error while fetching offers', response.status, response);
            store.dispatch(result);
        }
    }).catch(function (error) {
    });
}
export function getPackageFlightAlternatives(productRequest, storageKey, appendResponse, updateState) {
    if (storageKey === void 0) { storageKey = 'default'; }
    if (appendResponse === void 0) { appendResponse = false; }
    if (updateState === void 0) { updateState = true; }
    var protocol = store.getState().websiteState.app.location.protocol;
    var apiEndpoint = settings.coreApi.endPoints.package.base + settings.coreApi.endPoints.package.offers;
    if (updateState) {
        ClientHelper.abortPreviousRequest(store.getState().coreState.package.flightAlternatives.get(storageKey).abortController);
    }
    var abortController = new AbortController();
    var lastProducts = JSON.parse(JSON.stringify(store.getState().coreState.package.flightAlternatives.get(storageKey).products || []));
    if (updateState) {
        if (appendResponse) {
            ClientHelper.dispatchNewRequestAction(storageKey, PackageServiceActionTypes.REQUEST_MORE_PACKAGE_FLIGHT_ALTERNATIVES, abortController);
        }
        else {
            ClientHelper.dispatchNewRequestAction(storageKey, PackageServiceActionTypes.REQUEST_PACKAGE_FLIGHT_ALTERNATIVES, abortController);
        }
    }
    var result = {
        storageKey: storageKey,
        type: PackageServiceActionTypes.RECEIVE_PACKAGE_FLIGHT_ALTERNATIVES_RESPONSE,
        flightAlternatives: {},
        status: ResponseStatus.FAILED
    };
    fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
        signal: abortController.signal,
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: settings.coreApi.defaultPostHeaders,
        body: JSON.stringify(productRequest)
    }).then(function (response) {
        if (response.status === 200) {
            response.json().then(function (data) {
                result.flightAlternatives = data;
                if (data && data.pageInfo && data.pageInfo.size > 0) {
                    result.status = ResponseStatus.SUCCEED;
                }
                else {
                    result.status = ResponseStatus.EMPTY;
                }
                if (updateState) {
                    if (appendResponse) {
                        result.flightAlternatives['products'] = lastProducts.concat(data['products']);
                    }
                    store.dispatch(result);
                }
            });
        }
        else {
            console.error('Error while fetching flight alternatives', response.status, response);
            store.dispatch(result);
        }
    }).catch(function (error) {
    });
}
export function getPackageVariants(productVariantsRequest, storageKey) {
    if (storageKey === void 0) { storageKey = 'default'; }
    var protocol = store.getState().websiteState.app.location.protocol;
    var apiEndpoint = settings.coreApi.endPoints.package.base + settings.coreApi.endPoints.package.variants;
    ClientHelper.abortPreviousRequest(store.getState().coreState.package.variants.get(storageKey).abortController);
    var abortController = new AbortController();
    ClientHelper.dispatchNewRequestAction(storageKey, PackageServiceActionTypes.REQUEST_PACKAGE_VARIANTS, abortController);
    var result = {
        storageKey: storageKey,
        type: PackageServiceActionTypes.RECEIVE_PACKAGE_VARIANTS_RESPONSE,
        variants: {},
        status: ResponseStatus.FAILED
    };
    fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
        signal: abortController.signal,
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: settings.coreApi.defaultPostHeaders,
        body: JSON.stringify(productVariantsRequest)
    }).then(function (response) {
        if (response.status === 200) {
            response.json().then(function (data) {
                result.variants = data;
                if (data && data.pageInfo && data.pageInfo.size > 0) {
                    result.status = ResponseStatus.SUCCEED;
                }
                else {
                    result.status = ResponseStatus.EMPTY;
                }
                store.dispatch(result);
            });
        }
        else {
            console.error('Error while fetching variants', response.status, response);
            store.dispatch(result);
        }
    }).catch(function (error) {
    });
}
export function getPackageQueryOptions(request, storageKey) {
    if (storageKey === void 0) { storageKey = 'default'; }
    var protocol = store.getState().websiteState.app.location.protocol;
    var apiEndpoint = settings.coreApi.endPoints.package.base + settings.coreApi.endPoints.package.queryOptions;
    ClientHelper.abortPreviousRequest(store.getState().coreState.package.queryOptions.get(storageKey).abortController);
    var abortController = new AbortController();
    ClientHelper.dispatchNewRequestAction(storageKey, PackageServiceActionTypes.REQUEST_PACKAGE_QUERY_OPTIONS, abortController);
    var result = {
        storageKey: storageKey,
        type: PackageServiceActionTypes.RECEIVE_PACKAGE_QUERY_OPTIONS,
        queryOptions: {},
        status: ResponseStatus.FAILED
    };
    fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
        method: 'POST',
        mode: 'cors',
        headers: settings.coreApi.defaultPostHeaders,
        body: JSON.stringify(request)
    }).then(function (response) {
        if (response.status === 200) {
            response.json().then(function (data) {
                result.queryOptions = data;
                if (data) {
                    result.status = ResponseStatus.SUCCEED;
                }
                else {
                    result.status = ResponseStatus.EMPTY;
                }
                store.dispatch(result);
            });
        }
        else if (response.status === 204) {
            result.status = ResponseStatus.EMPTY;
            store.dispatch(result);
        }
        else {
            console.error('Error while fetching query options', response.status, response);
            store.dispatch(result);
        }
    }
    // tslint:disable-next-line:no-empty
    ).catch(function (error) {
    });
}
export function getPackageSuggestions(request, storageKey) {
    if (storageKey === void 0) { storageKey = 'default'; }
    var protocol = store.getState().websiteState.app.location.protocol;
    var apiEndpoint = settings.coreApi.endPoints.package.suggestions;
    ClientHelper.abortPreviousRequest(store.getState().coreState.package.suggestions.get(storageKey).abortController);
    var abortController = new AbortController();
    ClientHelper.dispatchNewRequestAction(storageKey, PackageServiceActionTypes.REQUEST_PACKAGE_SUGGESTIONS, abortController);
    var result = {
        storageKey: storageKey,
        type: PackageServiceActionTypes.RECEIVE_PACKAGE_SUGGESTIONS,
        suggestions: {},
        status: ResponseStatus.FAILED
    };
    fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
        method: 'POST',
        mode: 'cors',
        headers: settings.coreApi.defaultPostHeaders,
        body: JSON.stringify(request)
    }).then(function (response) {
        if (response.status === 200) {
            response.json().then(function (data) {
                result.suggestions = data;
                if (data) {
                    result.status = ResponseStatus.SUCCEED;
                }
                else {
                    result.status = ResponseStatus.EMPTY;
                }
                store.dispatch(result);
            });
        }
        else if (response.status === 204) {
            result.status = ResponseStatus.EMPTY;
            store.dispatch(result);
        }
        else {
            console.error('Error while fetching group query options', response.status, response);
            store.dispatch(result);
        }
    }
    // tslint:disable-next-line:no-empty
    ).catch(function (error) {
    });
}
export function getPackageGroupQueryOptions(request, storageKey) {
    if (storageKey === void 0) { storageKey = 'default'; }
    var protocol = store.getState().websiteState.app.location.protocol;
    var apiEndpoint = settings.coreApi.endPoints.package.base + settings.coreApi.endPoints.package.groupQueryOptions;
    ClientHelper.abortPreviousRequest(store.getState().coreState.package.groupQueryOptions.get(storageKey).abortController);
    var abortController = new AbortController();
    ClientHelper.dispatchNewRequestAction(storageKey, PackageServiceActionTypes.REQUEST_PACKAGE_GROUP_QUERY_OPTIONS, abortController);
    var result = {
        storageKey: storageKey,
        type: PackageServiceActionTypes.RECEIVE_PACKAGE_GROUP_QUERY_OPTIONS,
        groupQueryOptions: {},
        status: ResponseStatus.FAILED
    };
    fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
        method: 'POST',
        mode: 'cors',
        headers: settings.coreApi.defaultPostHeaders,
        body: JSON.stringify(request)
    }).then(function (response) {
        if (response.status === 200) {
            response.json().then(function (data) {
                result.groupQueryOptions = data;
                if (data) {
                    result.status = ResponseStatus.SUCCEED;
                }
                else {
                    result.status = ResponseStatus.EMPTY;
                }
                store.dispatch(result);
            });
        }
        else if (response.status === 204) {
            result.status = ResponseStatus.EMPTY;
            store.dispatch(result);
        }
        else {
            console.error('Error while fetching group query options', response.status, response);
            store.dispatch(result);
        }
    }
    // tslint:disable-next-line:no-empty
    ).catch(function (error) {
    });
}
